'use client';

import { useAtomValue, useSetAtom } from 'jotai';

import { filtersListAtom } from '@core/Atoms/Plp/FiltersListAtom';
import { SORT_KEY } from '@core/Constants/Sort';
import type { Locale } from '@core/Entities/Locale/Locale.entity';
import { getCorrectRelevanceForUk } from '@core/Utils/SearchFilters/AddDefaultSortingIfMissing';
import { getFilterFromArray } from '@core/Utils/SearchFilters/GetFilterFromArray';
import { Sort } from '@gds/Icons/Paths/Sort';
import type { Experiment } from '@growthBookExperimentation/Entities/Experiments.entities';
import { sortDrawerOpenAtom } from '@plp/Atoms/SortDrawerOpenAtom';

import type { SortMessages } from '../Filters/Components/Sort/Sort.messages';

import styles from './QuickFilters.module.css';

export const QuickFiltersSort = ({
  experiments,
  locale,
  sortMessages,
}: {
  experiments: Experiment[];
  locale: Locale;
  sortMessages: SortMessages;
}) => {
  const { FINAL_SORT_ORDER_UK, FINAL_DEFAULT_SORTING } = getCorrectRelevanceForUk(experiments);
  const openSortDrawer = useSetAtom(sortDrawerOpenAtom);
  const filtersList = useAtomValue(filtersListAtom);

  const sortFilter = getFilterFromArray(SORT_KEY, filtersList);

  const sortOptions = FINAL_SORT_ORDER_UK.map(option => ({
    label: sortMessages[option as keyof SortMessages],
    value: option,
  }));

  const selectedSortValue = sortFilter
    ? sortOptions.find(option => option.value === sortFilter?.value)
    : sortOptions.find(option => option.value === FINAL_DEFAULT_SORTING[locale]);

  return (
    <div className={styles.sort}>
      <button className="typography-subheading-3" onClick={() => openSortDrawer(true)}>
        {selectedSortValue?.label}
        <Sort />
      </button>
    </div>
  );
};
